import { render, staticRenderFns } from "./SpecificationsTable.vue?vue&type=template&id=004a4d79&"
import script from "./SpecificationsTable.vue?vue&type=script&lang=js&"
export * from "./SpecificationsTable.vue?vue&type=script&lang=js&"
import style0 from "./SpecificationsTable.vue?vue&type=style&index=0&id=004a4d79&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports